import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/auth.hook';

interface AuthWrapperProps {
    children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
    const { checkAuthStatus, isLoading } = useAuth();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        // Fallback timeout: if the server is down and checkAuthStatus hangs,
        // unblock the UI after 5 seconds to show the app / redirect login.
        const timeout = setTimeout(() => setIsInitialized(true), 5000);

        const initializeAuth = async () => {
            try {
                // Check auth status và refresh token nếu cần
                await checkAuthStatus();
            } catch (error) {
                console.error('Auth initialization error:', error);
            } finally {
                clearTimeout(timeout);
                setIsInitialized(true);
            }
        };

        initializeAuth();
    }, []); // Empty dependency to run only once on mount

    // Show loading only while loading and not initialized
    if (!isInitialized && isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    // Render children even when the token expires.
    // Auth middleware will handle redirect if needed.
    return <>{children}</>;
}
